import { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { getLocalDateStrFromDate, getLocalTimeStrFromDate, getLocalizedDate } from '../../utils/time';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

/**
 * Dropdown that allows to select a single items. Select choices are applied immediately.
 */
export const CustomDateSelector = ({ setIsHistoricalView, setShow, filterDateOptions, setFilterDateOptions, disabled }: any) => {
    const wrapperRef: any = useRef(null);
    const [localAbsoluteStartDate, setLocalAbsoluteStartDate] = useState<string>(getLocalDateStrFromDate(filterDateOptions["absoluteStart"]));
    const [localAbsoluteStartTime, setLocalAbsoluteStartTime] = useState<string>(getLocalTimeStrFromDate(filterDateOptions["absoluteStart"]));

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShow(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const applyTime = () => {
        setFilterDateOptions({
            absoluteStart: getLocalizedDate(localAbsoluteStartDate, localAbsoluteStartTime),
        });
        setShow(false);
        if (getLocalDateStrFromDate(new Date()) !== localAbsoluteStartDate || getLocalTimeStrFromDate(new Date()) !== localAbsoluteStartTime) {
            setIsHistoricalView(true);
        } else {
            setIsHistoricalView(false);
        }
    };

    return (
        <div ref={wrapperRef} className="filter-select-container" style={{right: '0%', top: '32px', paddingTop: '12px', paddingBottom: '6px', zIndex: '99999'}}>
            <div style={{minWidth: '240px'}}>
                <Container>
                    <Row>
                        <Col>
                            <Form.Control type="date" name='startDate' value={localAbsoluteStartDate} onChange={(event: any) => {setLocalAbsoluteStartDate(event.target.value)}} />
                            <Form.Control className="mt-1" type="time" name='startTime' value={localAbsoluteStartTime} onChange={(event: any) => {setLocalAbsoluteStartTime(event.target.value)}} />
                        </Col>
                    </Row>
                    <Row className="pt-2 pb-1">
                        <Col md={8}>
                            <Button variant="outline-secondary" size="sm" onClick={() => {setLocalAbsoluteStartDate(getLocalDateStrFromDate(new Date())); setLocalAbsoluteStartTime(getLocalTimeStrFromDate(new Date()))}}><FontAwesomeIcon icon={faClock} />{' '}Now</Button>
                        </Col>
                        <Col md={4} className="float-end">
                            <Row className="float-end">
                                <Col>
                                    <Button variant="secondary" size="sm" onClick={() => applyTime()}>Apply</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

